
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fyrirtaeki",
      function () {
        return require("private-next-pages/fyrirtaeki/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fyrirtaeki"])
      });
    }
  